import React, { FunctionComponent } from 'react';

import { default as MuiTabs, TabsProps } from '@mui/material/Tabs';

const Tabs: FunctionComponent<TabsProps<React.ElementType>> = ({
  children,
  value,
  onChange,
  sx,
  TabIndicatorProps,
}: TabsProps<React.ElementType>) => {
  return (
    <MuiTabs
      value={value}
      onChange={onChange}
      sx={sx}
      TabIndicatorProps={TabIndicatorProps}
    >
      {children}
    </MuiTabs>
  );
};

export default Tabs;
